<template>
  <div class="content clickable" @click="click" v-if="checkIsCVQuaHan">
    <span>Bạn có công việc</span>
    <span style="color: #262626; font-weight: 700">{{ quote }}</span>
    <span
      :class="['highlight-action', remainingDay >= 0 ? 'warning' : 'alert']"
      >{{ state }}</span
    >
  </div>
  <div v-else class="content clickable" @click="click">
    <span>Ông/bà</span>
    <span class="highlight font-weight__bold">{{ actorFullName }}</span>
    <span>đã</span>
    <span class="highlight-action">{{ actionName }}</span>
    <span v-if="checkIsVbNotificationV2"
      >văn bản
      <template v-if="!!docCode">
        <span class="font-weight__bold">#{{ docCode }}</span>
      </template>
      <template v-if="!!docDate">
        ngày
        <span class="font-weight__bold">{{
          docDate | dateFormatter({ dateFormat: "DD/MM/YYYY" })
        }}</span>
      </template>
    </span>
    <span v-else-if="checkIsVbNotificationV1">trong văn bản về việc</span>
    <span v-else-if="checkIsCVNotification">công việc</span>
    <span v-else-if="checkIsLetter">đơn</span>
    <span v-else>về</span>
    <span class="event font-italic">"{{ quote }}"</span>
  </div>
</template>

<script>
import dateFormatter from "../../../filters/dateFormatter";

export default {
  name: "doc-notification-item-template",
  props: [
    "actorFullName",
    "actionName",
    "docCode",
    "docDate",
    "quote",
    "checkIsVbNotificationV1",
    "checkIsVbNotificationV2",
    "checkIsCVNotification",
    "checkIsCVQuaHan",
    "checkIsLetter",
    "state",
    "remainingDay"
  ],
  filters: { dateFormatter },
  methods: {
    click(event) {
      this.$emit("click", event);
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/common/layout/doc-notification-item-template.vue